import * as React from 'react';
import { CopyableField } from '@css-xp/base';
import { DEVELOPMENT, getCurrentEnvironment, PRODUCTION, STAGING } from '@atlassian/temp-shared';

export interface Props {
  selfServeBACInvoiceLink: string | null;
  transactionAccountId: string | null;
  isPartnerAccount: boolean;
  invoiceId: string;
}

const generatePPCInvoiceLink = (transactionAccountId: string, invoiceId: string) => {
  let baseUrl;
  const env = getCurrentEnvironment();
  switch (env) {
    case PRODUCTION:
      baseUrl = 'https://ppc.atlassian.com/account/';
      break;
    case STAGING:
      baseUrl = 'https://ppc.stg.atlassian.com/account/';
      break;
    case DEVELOPMENT:
      baseUrl = 'https://ppc.dev.atlassian.com/account/';
      break;
    default:
      baseUrl = 'https://ppc.stg.atlassian.com/account/';
      break;
  }

  return `${baseUrl}${transactionAccountId}/invoices/${invoiceId}`;
};

const SelfServeBACInvoiceLink = ({
  selfServeBACInvoiceLink,
  transactionAccountId,
  isPartnerAccount,
  invoiceId,
}: Props) => {
  return (
    <>
      <h3>Self-serve invoice link</h3>

      <div data-testid="self-serve-link-basic">
        {isPartnerAccount && transactionAccountId ? (
          <CopyableField
            autoSelect={false}
            value={generatePPCInvoiceLink(transactionAccountId, invoiceId)}
            label="Basic link"
            testId="copy-field-basic-link"
          />
        ) : (
          <CopyableField
            autoSelect={false}
            value={`${selfServeBACInvoiceLink}`}
            label="Basic link"
            testId="copy-field-basic-link"
          />
        )}
      </div>
    </>
  );
};

export default SelfServeBACInvoiceLink;
